import Immutable from 'immutable';

import RecordFactory from '../../models/RecordFactory';

/**
 * Записи вида кладутся в сцену под своим ключом, рядом с их количеством.
 *
 * Каждый режим вида хранит выборку отдельно (records, calendarRecords, ganttRecords и так
 * далее), поэтому ключ приходит снаружи.
 */
export default function setViewRecords(store, sceneId, key, records) {
  if (!store.getIn(['scenes', sceneId])) return;

  const recordsMap = {};
  records.forEach((record, index) => {
    recordsMap[index] = RecordFactory.create(record);
  });

  store.setIn(['scenes', sceneId, key], Immutable.Map(recordsMap));
  store.setIn(['scenes', sceneId, `${key}Count`], records.length);
  store.changed();
}
